import { useEffect, useState } from "react";
import { Select, DatePicker, Button, Input } from "antd";
import eventBg8 from '../../img/event/eventBg-8.png';
import eventBg9 from '../../img/event/eventBg-9.png';
import { useHistory } from 'react-router-dom';
import EventDetail from '../etc/EventDetail';
import moment from 'moment';
import EventResult from "./EventResult";
import image from '../../res/image';

const Event = ({ joinAbleCount, eventIdx, showResult }) => {

    const history = useHistory();
    const [visible, setVisible] = useState(true);
    const [banner, setBanner] = useState(0);
    const [openEventDetail, setOpenEventDetail] = useState(0);

    const changeBanner = () => {
        const now = new Date();
        var date = moment(now)
        var septemberBanner = moment("26/08/2023 00:00:00", "DD/MM/YYYY HH:mm:ss")

        if (date.isAfter(septemberBanner)) {
            setBanner(1)
        }
    }



    const close = () => {
        setVisible(false)
    }

    // 이전방문 날짜
    const VISITED_BEFORE_DATE = localStorage.getItem('EventCookieRenew2');
    // 현재 날짜
    const VISITED_NOW_DATE = Math.floor(new Date().getDate());

    useEffect(() => {
        changeBanner();
        // 팝업 오늘 하루닫기 체크
        if (VISITED_BEFORE_DATE !== null) {
            // 날짜가 같을경우 노출
            if (Number(VISITED_BEFORE_DATE) === VISITED_NOW_DATE) {
                localStorage.removeItem('EventCookieRenew2');
                close(true);
            }
            // 날짜가 다를경우 비노출
            if (Number(VISITED_BEFORE_DATE) !== VISITED_NOW_DATE) {
                close(false);
            }
        }
    }, [VISITED_BEFORE_DATE]);



    // 하루동안 팝업 닫기
    const Dayclose = (e) => {
        if (close) {
            close(e);

            const expiry = new Date();
            // +1일 계산
            const expiryDate = expiry.getDate() + 1;
            // 로컬스토리지 저장
            localStorage.setItem('EventCookieRenew2', expiryDate);
        }
    };
    const eventDetail = () => {
        if (showResult) setOpenEventDetail(2);
        else setOpenEventDetail(1)
    }
    const closeEventDetail = () => {
        setOpenEventDetail(0);
    }

    return (
        <>
            <div className="roullete">
                {visible ?
                    <div className="roullete-content" >
                        <div className="roullete-day-close" onClick={Dayclose}>
                            <div className="close-txt"> 오늘 그만 보기 </div>
                        </div>
                        <div className="roullete-close" onClick={() => setVisible(false)}>
                            <div className="close-bg" >
                                <img src={image.closeIcon} alt=""
                                />
                            </div>
                        </div>


                        <div className="roullete-img">
                            {banner === 1 ?
                                <img style={{
                                    width: '100%',
                                }} src={eventBg9} alt="" onClick={eventDetail} />
                                :
                                <img style={{
                                    width: '100%',
                                }} src={eventBg8} alt="" onClick={eventDetail} />}
                        </div>
                    </div>
                    :
                    <></>
                }

            </div>
            {openEventDetail === 1 && <EventDetail joinAbleCount={joinAbleCount} eventIdx={eventIdx} closeEventDetail={closeEventDetail} />}
            {openEventDetail === 2 && <EventResult joinAbleCount={joinAbleCount} eventIdx={eventIdx} closeEventDetail={closeEventDetail} />}
        </>
    )

}

export default Event;
